<script setup lang="ts">
import { KirbyBlock } from "../../queries/blocks"
import Image from "./Block/Image.vue"
import Sketchfab from "./Block/Sketchfab.vue"
import Video from "./Block/Video.vue"

const props = defineProps<{
  blocks: KirbyBlock<string>[]
  components?: Partial<Record<string, any>>
  aspect?: number
}>()

const emit = defineEmits<{
  open: [index: number]
  captionChange: [caption: string]
}>()

const canHover =
  typeof window !== "undefined" &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches

const getBlockCaption = (block: KirbyBlock<string>) => {
  const content = block.content as { caption?: string } | undefined
  return content?.caption ?? ""
}

const onBlockMouseEnter = (block: KirbyBlock<string>) => {
  if (!canHover) return
  emit("captionChange", getBlockCaption(block))
}

const onBlockMouseLeave = () => {
  if (!canHover) return
  emit("captionChange", "")
}

const blockComponents: Partial<Record<string, any>> = {
  image: Image,
  video: Video,
  sketchfab: Sketchfab,
}
</script>

<template>
  <div
    v-for="(block, index) in blocks"
    class="aspect-square w-full relative overflow-hidden md:hover:scale-105 transition-transform"
    @mouseenter="onBlockMouseEnter(block)"
    @mouseleave="onBlockMouseLeave"
  >
    <div
      class="flex w-full h-full items-center justify-center absolute inset-0"
    >
      <component
        v-if="blockComponents[block.type]"
        :is="blockComponents[block.type]"
        :block="block"
        @open="emit('open', index)"
      />
    </div>
  </div>
</template>
